const datatable_lang = {
  body: {
    noMatch: 'Chưa có dữ liệu',
    toolTip: 'Sắp xếp',
    columnHeaderTooltip: column => `Sắp xếp theo ${column.label}`
  },
  pagination: {
    next: 'Tiếp',
    previous: 'Quay lại',
    rowsPerPage: 'Hàng trên trang:',
    displayRows: 'của'
  },
  toolbar: {
    search: 'Tìm kiếm',
    downloadCsv: 'Download CSV',
    print: 'In',
    viewColumns: 'Hiển thị các cột',
    filterTable: 'Lọc'
  },
  filter: {
    all: 'Tất cả',
    title: 'LỌC',
    reset: 'BỎ LỌC'
  },
  viewColumns: {
    title: 'Hiển thị các cột',
    titleAria: 'Hiển thị/Ẩn cột trong bảng'
  },
  selectedRows: {
    text: 'hàng đã chọn',
    delete: 'Xóa',
    deleteAria: 'Xóa các hàng đã chọn'
  }
};

export { datatable_lang };
